<template>
    <div :class="$style.wrapper">
        <h3 class="m-2 mb-3">Employee Resources</h3>

        <div class="m-2">
            <div class="row">
                <div class="col-sm-6">
                    <PortalResource
                        v-for="item in items.slice(0, 3)"
                        :key="item.name"
                        :item="item"
                    />
                </div>
                <div class="col-sm-6">
                    <PortalResource v-for="item in items.slice(3)" :key="item.name" :item="item" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PortalResource from './PortalResource.vue';

export default {
    components: { PortalResource },
    props: {
        dashboardUrl: String,
        compassUrl: String,
        canAccessCompass: Boolean,
    },
    data() {
        const items = [
            {
                name: 'My Dashboard',
                icon: 'fa-solid fa-tachometer-alt',
                description: 'Nautilus',
                url: this.dashboardUrl,
                color: '#007BFF',
            },
            {
                name: 'Timekeeping',
                icon: 'fa-solid fa-clock',
                description: 'TeamKeeper',
                url: 'https://nmmpf-online.teamkeeper.com',
                color: '#CE93D8',
            },
            {
                name: 'Paystubs & Documents',
                icon: 'fa-solid fa-file-invoice-dollar',
                description: 'eSelfServe',
                url: 'https://eselfserve.com',
                color: '#17A2B8',
            },
            ...(this.canAccessCompass
                ? [
                      {
                          name: 'Performance',
                          icon: 'fa-solid fa-person-circle-check',
                          description: 'Compass',
                          url: this.compassUrl,
                          color: '#81C784',
                      },
                  ]
                : []),
            {
                name: 'Retirement',
                icon: 'fa-solid fa-chart-mixed-up-circle-dollar',
                description: 'JULY Services',
                url: 'https://julyservices.com',
                color: '#90CAF9',
            },
            {
                name: 'Employee Handook',
                icon: 'fa-solid fa-book',
                description: 'Google Drive',
                url: 'https://drive.google.com/drive/u/0/folders/1KaOoQd009IrW3nXQshDZZwbbpmzCEsPe',
                color: '#BCAAA4',
            },
        ];

        return { items };
    },
};
</script>

<style lang="scss" module>
.wrapper {
    max-width: 800px;

    a {
        color: black;

        i {
            color: white;
        }
    }
}
</style>
